import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import { TextFormattedNumber } from 'components';


const OrderDiscountsCoupons = ({order}) => {
  const {
    extension_attributes,
    extension_attributes: {
      mp_reward: {
        mp_reward_discount,
        mp_reward_earn,
      }
    },
    base_discount_amount,
    base_discount_invoiced,
    coupon_code
  } = order;

  const quoteDiscount = Math.abs(base_discount_invoiced) - (Math.abs(base_discount_amount) || 0);

  //TODO: need requirements for Gift Card discounts fields
  return (
    <TableContainer>
      <Table className="inheritTable">
        <TableHead>
          <TableRow>
            <TableCell width="10%" />
            <TableCell>Discount</TableCell>
            <TableCell width="3%" />
            <TableCell>Coupon code</TableCell>
            <TableCell width="3%" />
            <TableCell>Gift Cards</TableCell>
            <TableCell width="3%" />
            <TableCell>Points</TableCell>
            <TableCell width="10%" />
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell width="10%" />
            <TableCell className="align-top">
              {!!base_discount_amount &&
                <div className="flex-column pr-10 my-5">
                  <div className="flex items-center flex-wrap">
                    <span>Discount: </span>
                    <TextFormattedNumber
                      value={Math.abs(base_discount_amount)}
                      prefix="$"
                    />
                  </div>
                </div>
              }
              {!!quoteDiscount &&
                <div className="flex-column pr-10 my-5">
                  <div className="flex items-center flex-wrap">
                    <span>Quote Discount: </span>
                    <TextFormattedNumber
                      value={quoteDiscount}
                      prefix="$"
                    />
                  </div>
                </div>
              }
            </TableCell>
            <TableCell width="3%" />
            <TableCell className="align-top">
              {!!coupon_code &&
                <div className="my-5">
                  <span>{coupon_code}</span>
                </div>
              }
            </TableCell>
            <TableCell width="3%" />
            <TableCell className="align-top">
              {extension_attributes?.gift_card_code &&
                <div className="flex-column pr-10 my-5">
                  <div className="flex items-center justify-between flex-wrap">
                    <span>Gift Card ({extension_attributes.gift_card_code})</span>
                    <TextFormattedNumber
                      value={Math.abs(extension_attributes.gift_card_value)}
                      prefix="$"
                    />
                  </div>
                </div>
              }
              {extension_attributes?.credit &&
                <div className="flex-column pr-10 my-5">
                  <div className="flex items-center justify-between flex-wrap">
                    <span>Credit</span>
                    <TextFormattedNumber
                      value={Math.abs(extension_attributes.credit)}
                      prefix="$"
                    />
                  </div>
                </div>
              }
            </TableCell>
            <TableCell width="3%" />
            <TableCell className="align-top">
              {mp_reward_earn ?
                <div className="flex-column pr-15 my-5">
                  <div className="flex items-center justify-between flex-wrap">
                    <span>Earn</span>
                    <span>{mp_reward_earn} {mp_reward_earn == 1 ? 'point' : 'points'}</span>
                  </div>
                </div>
                : '---'
              }
              {mp_reward_discount ?
                <div className="flex-column pr-15 my-5">
                  <div className="flex items-center justify-between flex-wrap">
                    <span>Spent</span>
                    <span>{mp_reward_discount} {mp_reward_discount == 1 ? 'point' : 'points'}</span>
                  </div>
                </div>
                : '---'
              }
            </TableCell>
            <TableCell width="10%" />
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default OrderDiscountsCoupons;
